import React from 'react';
import { ShieldCheck, Bot, Globe } from 'lucide-react';
import './ReputationFirewall.css';

const ReputationFirewall = () => {
  return (
    <section className="firewall section" id="firewall" data-testid="firewall-section">
      <div className="container">
        <div className="firewall-content">
          <div className="firewall-visual">
            <div className="firewall-diagram">
              <div className="firewall-node firewall-node-left">
                <Bot size={32} />
                <span>AI Systems</span>
              </div>
              <div className="firewall-shield">
                <div className="shield-glow"></div>
                <ShieldCheck size={48} />
                <span className="shield-label">VantaSignal</span>
              </div>
              <div className="firewall-node firewall-node-right">
                <Globe size={32} />
                <span>Public Channels</span>
              </div>
              <div className="firewall-line firewall-line-left"></div>
              <div className="firewall-line firewall-line-right"></div>
            </div>
          </div>
          
          <div className="firewall-text">
            <h2 className="firewall-title" data-testid="firewall-title">
              The Firewall for AI Communication
            </h2>
            <p className="firewall-description" data-testid="firewall-description">
              VantaSignal acts as a governance firewall between AI systems and public communication channels.
            </p>
            <div className="firewall-features">
              <div className="firewall-feature">
                <div className="feature-dot"></div>
                <span>Real-time content screening</span>
              </div>
              <div className="firewall-feature">
                <div className="feature-dot"></div>
                <span>Policy enforcement at scale</span>
              </div>
              <div className="firewall-feature">
                <div className="feature-dot"></div>
                <span>Zero-trust communication architecture</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReputationFirewall;
